export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',

  // Xudo (X Role)
  'menu.xudo': 'X CENTER',
  'menu.xudo.xhub': 'Hubs',
  'menu.xudo.xvendor': 'Vendors',
  'menu.xudo.game': 'Games',
  'menu.xudo.players': 'Players',
  'menu.xudo.transactions': 'Game Transactions',
  'menu.xudo.control-center': 'Control Center',
  'menu.xudo.social-platform-automation': 'Social Platform Automation',

  // Org Dashboard
  'menu.org': 'Dashboard',
  'menu.org.home': 'Dashboard',
  'menu.xudo.member': 'Owner',
  'menu.xudo.interface-events': 'Interface Events',
  'menu.org.vendor': 'Vendor',
  'menu.org.game': 'Games',
  'menu.org.gsessions': 'Game Sessions',
  'menu.org.analysis': 'Analysis',
  'menu.org.ggr-tier-config': 'GGR Tier Config',
  'menu.org.ggrtiers': 'ตั้งค่า GGR Tier',
  'menu.org.ggrtiers-detail': 'GGR Information',

  // Management
  'menu.management': 'Management',
  'menu.management.site-list': 'Sites',
  'menu.management.players': 'Players',
  'menu.management.players.detail': 'Player Detail',

  'menu.management.vendor': 'Vendor',
  'menu.management.game': 'Games',
  'menu.management.game.category': 'Game Categories',
  'menu.management.game.all': 'All',
  'menu.management.game.electronic': 'Electronic',
  'menu.management.game.slot': 'Slot',
  'menu.management.game.table': 'Table',
  'menu.management.game.live': 'Live',
  'menu.management.game.lottery': 'Lottery',
  'menu.management.game.fish': 'Fish',
  "menu.management.game.card": "Card",
  "menu.management.game.poker": "Poker",
  "menu.management.game.arcade": "Arcade",
  "menu.management.game.animal": "Animal",
  'menu.management.game.sport': 'Sport',
  'menu.management.game.esport': 'E-Sport',
  'menu.org.brand': 'Brand',
  'menu.management.contents': 'Contents',
  'menu.management.player-finance-operations': 'Processing Transactions',
  'menu.management.social-links': 'Social Links',
  'menu.management.payment-methods': 'Payment Methods',
  'menu.management.payment': 'Payment',
  'menu.management.payment.config': 'Configuration',
  'menu.management.payment.bank-accounts': 'Bank Accounts',
  'menu.settings.fund': 'Finance',
  'menu.settings.finance': 'Finance',
  'menu.management.provision': 'Provision Site',
  'menu.management.provision-status': 'Provision Status',

  // Dashboard
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.vendor': 'Vendor',
  'menu.dashboard.game': 'Games',
  'menu.dashboard.gsessions': 'Game Sessions',
  'menu.dashboard.workplace': 'Workplace',
  'menu.dashboard.control-center': 'Control Center',

  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.settings': 'Account & Settings',
  'menu.settings.account': 'Account',
  'menu.settings.api-config': 'API Config',
  'menu.settings.social-links': 'Social Links',
  'menu.settings.payment-methods': 'Payment Methods',
  'menu.settings.typography': 'Typography',

  // Social Links
  'menu.settings.socialLinks': 'Social Links',
  'pages.settings.socialLinks.saveSuccess': 'Save successfully',
  'pages.settings.socialLinks.saveError': 'Failed to save social links',
  'pages.settings.socialLinks.title': 'Social Links',
  'pages.settings.socialLinks.description':
    'Connect your social media account to display in your profile',
  'pages.settings.socialLinks.website': 'Website',
  'pages.settings.socialLinks.facebook': 'Facebook',
  'pages.settings.socialLinks.twitter': 'Twitter / X',
  'pages.settings.socialLinks.instagram': 'Instagram',
  'pages.settings.socialLinks.youtube': 'YouTube',
  'pages.settings.socialLinks.linkedin': 'LinkedIn',
  'pages.settings.socialLinks.github': 'GitHub',
  'pages.settings.socialLinks.discord': 'Discord',
  'pages.settings.socialLinks.telegram': 'Telegram',

  // Payment Methods
  'menu.settings.paymentMethods': 'Payment Methods',
  'pages.settings.paymentMethods.title': 'Payment Methods',
  'pages.settings.paymentMethods.description': 'Configure payment methods available for deposits and withdrawals',
  'pages.settings.paymentMethods.saveSuccess': 'Payment methods saved successfully',
  'pages.settings.paymentMethods.saveError': 'Failed to save payment methods',
  'pages.settings.paymentMethods.enabled': 'Enabled',
  'pages.settings.paymentMethods.disabled': 'Disabled',
  'pages.settings.paymentMethods.minAmount': 'Minimum Amount',
  'pages.settings.paymentMethods.maxAmount': 'Maximum Amount',
  'pages.settings.paymentMethods.depositFee': 'Deposit Fee (%)',
  'pages.settings.paymentMethods.withdrawalFee': 'Withdrawal Fee (%)',
  'pages.settings.paymentMethods.apiKey': 'API Key',
  'pages.settings.paymentMethods.merchantId': 'Merchant ID',
  'pages.settings.paymentMethods.save': 'Save Changes',
  'pages.settings.paymentMethods.reset': 'Reset',
  'pages.settings.paymentMethods.creditDebit': 'Credit/Debit Cards',
  'pages.settings.paymentMethods.ewallets': 'E-wallets',
  'pages.settings.paymentMethods.bankTransfer': 'Bank Transfer',
  'pages.settings.paymentMethods.cryptocurrency': 'Cryptocurrency',
  'pages.settings.paymentMethods.mobilePayment': 'Mobile Payment',
  'pages.settings.paymentMethods.regional': 'Regional Methods',
  'pages.settings.paymentMethods.localTransfer': 'Local Transfer',
  'pages.settings.paymentMethods.ewallet': 'E-Wallet',
  'pages.settings.paymentMethods.card': 'Card Payment',


  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  // Micro Frontend
  'micro.loading': 'Loading Micro App...',
  'micro.error.title': 'Failed to load Micro App',
  'micro.error.description':
    'Please check if qiankun plugin is enabled in config/config.ts',
  'micro.notReady': 'Micro Frontend is not ready',

  // Provision Page
  'provision.title': 'Provision New Site',
  'provision.step.selectTemplate': 'Select Template',
  'provision.step.configure': 'Configure Site',
  'provision.step.provision': 'Provision',
  'provision.template.title': 'Choose a Template',
  'provision.template.selectRequired': 'Please select a template',
  'provision.template.selected': 'Selected',
  'provision.template.estimatedTime': 'Estimated time',
  'provision.config.title': 'Site Configuration',
  'provision.config.siteName': 'Site Name',
  'provision.config.siteName.placeholder': 'my-awesome-site',
  'provision.config.siteName.required': 'Please enter a site name',
  'provision.config.siteName.pattern':
    'Only lowercase letters, numbers, and hyphens allowed',
  'provision.config.siteName.min': 'Minimum 3 characters',
  'provision.config.environment': 'Environment',
  'provision.config.environment.sandbox': 'Sandbox (Testing)',
  'provision.config.environment.uat': 'UAT (Staging)',
  'provision.config.environment.production': 'Production (Live)',
  'provision.config.currency': 'Default Currency',
  'provision.config.theme': 'Theme',
  'provision.config.theme.default': 'Default',
  'provision.config.theme.dark': 'Dark Mode',
  'provision.config.theme.light': 'Light Mode',
  'provision.ready.title': 'Ready to Provision',
  'provision.ready.description':
    'Your site will be created with the following configuration:',
  'provision.info.title': 'Information',
  'provision.info.template': 'Template: Pre-configured database schema',
  'provision.info.environment': 'Environment: Isolated deployment environment',
  'provision.info.provisioning': 'Provisioning: Automated setup with Neon',
  'provision.btn.previous': 'Previous',
  'provision.btn.next': 'Next',
  'provision.btn.provision': 'Provision Site',
  'provision.success.title': 'Site Provisioned Successfully!',
  'provision.success.description': 'Your site {siteName} is now ready!',
  'provision.success.connection.title': 'Connection Details',
  'provision.success.connection.host': 'Database Host',
  'provision.success.connection.dbName': 'Database Name',
  'provision.success.connection.uri': 'Connection URI',
  'provision.success.connection.copy': 'Click to copy full URI',
  'provision.success.btn.management': 'Go to Site Management',
  'provision.status.started': 'Provisioning started!',
  'provision.status.failed': 'Failed to provision site',
  'provision.status.success': 'Site provisioned successfully!',

  // Quota Page
  'fund.title': 'Fund & Billing',
  'fund.fund.amount': 'Amount',
  'fund.fund.button': 'Deposit',
  'fund.fund.minAmount': 'Min 100.000000 USDT',
  'fund..title': 'Funding',
  'fund.topup.usdtOnly': 'ONLY USDT IS ACCEPTED FOR FUNDING ACCOUNT.',
  'fund.tab.domains': 'Funding',
  'fund.tab.purchase': 'Purchase Quota',
  'fund.tab.history': 'Transaction History',
  'fund.balance.title': 'Balance',
  'fund.balance.pending': 'Pending',
  'fund.balance.totalDeposited': 'Total Deposited',
  'fund.balance.totalSpent': 'Total Spent',
  'fund.howItWorks.title': 'How it works',
  'fund.howItWorks.step1': 'Select a fund package',
  'fund.howItWorks.step2': 'Enter your site name',
  'fund.howItWorks.step3': 'Pay with cryptocurrency (USDT, BTC, ETH)',
  'fund.howItWorks.step4': 'Site is automatically provisioned',
  'fund.package.title': 'Select Quota Package',
  'fund.siteConfig.title': 'Site Configuration',
  'fund.siteConfig.name': 'Site Name',
  'fund.siteConfig.name.placeholder': 'my-awesome-site',
  'fund.siteConfig.name.hint':
    'This will be the unique identifier for your site',
  'fund.siteConfig.package': 'Package',
  'fund.siteConfig.fund': 'Quota',
  'fund.siteConfig.price': 'Price',
  'fund.siteConfig.discount': 'Discount',
  'fund.purchase.btn': 'Purchase for {price}',
  'fund.table.date': 'Date',
  'fund.table.type': 'Type',
  'fund.table.fund': 'Quota',
  'fund.table.amount': 'Amount',
  'fund.table.status': 'Status',
  'fund.table.site': 'Site',
  'fund.warning.selectPackage': 'Please select a fund package',
  'fund.warning.enterSiteName': 'Please enter a site name',
  'menu.virtual-world': 'Virtual World',
  'menu.virtual-world.items': 'Consumable Items',
  'menu.virtual-world.gifts': 'Gifts',
  'menu.virtual-world.promotions': 'Promotions',
  'menu.reports': 'Reports',
  'menu.reports.finance': 'Financial Report',
  'menu.reports.members': 'Member Report',
  'menu.reports.games': 'Game Report',
  'menu.reports.bonus': 'Bonus Report',
};
